module.exports = __webpack_public_path__ + "img/4.cb9a13f4.jpg";